import React, { PropTypes, Component } from 'react';
import { VideoPlayer } from 'components/Widgets';
import classNames from 'classnames';
import { Media } from 'Util';
import { Colors } from 'Css';
import shallowEqual from 'shallowequal';

const css = oxygenCss({
  root: {
    margin: 'auto',
    width: '100%'
  },
  container: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0
  },
  normalContainer: {
    position: 'relative'
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none'
  },
  caption: {
    textAlign: 'center',
    fontStyle: 'italic',
    color: Colors.text.Dark.disabled
  }
});

export default class StoreVideoPlayer extends Component {
  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.string,
    caption: PropTypes.string
  };

  parseVideoUrl(videoUrl) {
    try {
      const provider = JSON.parse(videoUrl);
      provider.id = provider.src;
      const parsedUrl = Media.getUrlFromProvider(provider);
      return parsedUrl;
    } catch (e) {
      try {
        const parsedUrl = Media.getEmbedUrl(videoUrl);
        return parsedUrl;
      } catch (e1) {
        return videoUrl;
      }
    }
    return videoUrl;
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  renderIFrame(src) {
    const { caption } = this.props;
    return (
      <div>
        <div className={css.root}>
          <div className={css.container}>
            <iframe
              className={css.iframe}
              src={src}
              allowTransparency
              frameBorder={0}
              scrolling={'no'}
              webkitAllowFullScreen
              mozAllowFullScreen
              allowFullSreen
              oAllowFullScreen
              msAllowFullScreen
            />
          </div>
        </div>
        {caption && <figcaption className={css.caption}>{caption}</figcaption>}
      </div>
    );
  }

  getExtension(input) {
    const url = input || '';
    return url.substr((~-url.lastIndexOf('.') >>> 0) + 2);
  }

  renderVideoPlayer(src) {
    const { caption } = this.props;
    return (
      <div>
        <VideoPlayer sources={[{ url: src, type: this.getExtension(src) }]} />
        {caption && <figcaption className={css.caption}>{caption}</figcaption>}
      </div>
    );
  }

  renderEmptyVideo() {
    const { caption } = this.props;
    return (
      <div>
        <VideoPlayer sources={[]} />
        {caption && <figcaption className={css.caption}>{caption}</figcaption>}
      </div>
    );
  }

  render() {
    const { src } = this.props;
    const videoUrl = this.parseVideoUrl(src);
    if (src !== videoUrl) {
      return this.renderIFrame(videoUrl);
    } else if (src) {
      return this.renderVideoPlayer(src);
    } else {
      return this.renderEmptyVideo();
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreVideoPlayer.js